/**
 * @file
 * Provide a jQuery plugin to create an accordion.
 *
 * The function can be applied to any jQuery object, which then behave as
 * an accordion. The function accept two options to set the trigger- and the
 * content-element.
 *
 * 'trigger' and 'content' needs to be child-nodes of the element on which
 * the function is applied.
 *
 * e.g. $('.accordion').createAccordion({
 *   trigger: ".accordion__title",
 *   content: ".accordion__content"
 * });
 */

(function ($) {
  const eventNamespace = 'aw.accordion';

  $.fn.createAccordion = function (options) {

    let $accordion = this;

    const settings = $.extend({
      trigger: ".accordion__title",
      content: ".accordion__content"
    }, options);
    let accordionTrigger = $accordion.find(settings.trigger);
    once('awAccordionClickEventhandler', accordionTrigger).forEach(function(currentElement) {
      currentElement.addEventListener('click', toggleAccordion);
    })

    function toggleAccordion() {
      const activeClass = 'is-active';
      const $parentAccordion = $(this).parent($accordion);
      $parentAccordion.toggleClass(activeClass).find(settings.content).slideToggle('fast');

      // Fire event according to final status.
      const eventName = `${eventNamespace}.${$accordion.hasClass(activeClass) ? 'opened' : 'collapsed'}`;
      $parentAccordion.trigger(eventName);

      Drupal.attachBehaviors(document, Drupal.settings);
    }

  };
})(jQuery);
